window.bindQuickAddForms = function () {
  document.querySelectorAll('.quick-add-form').forEach(form => {
    if (form.dataset.bound === "true") return;
    form.dataset.bound = "true";

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.innerHTML;

      submitBtn.disabled = true;
      submitBtn.innerHTML = `${originalText} <span class="added-check">✔</span>`;

      try {
        const response = await fetch( theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
          },
          body: formData,
        });

        if (!response.ok) throw new Error('Erreur lors de l’ajout');

        const addedProduct = await response.json();

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: addedProduct }
        }));

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        submitBtn.innerHTML = `${originalText} <span class="added-check">✔</span>`;
        submitBtn.classList.add('added');

        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
          submitBtn.classList.remove('added');
        }, 1500);

      } catch (error) {
        submitBtn.innerHTML = 'Erreur';
        console.error('Erreur lors de l’ajout au panier:', error);
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });
};

document.addEventListener('recommendations:loaded', function(evt) {
window.bindQuickAddForms();
});